export const GEO_SERVICES_BASE_URL = process.env.GEO_SERVICES_BASE_URL;
